<template>
  <div :class="[$style.base, selected ? $style.selected : {}]">
    <span :class="[$style.selection, selected ? $style.selectionSelected : {}]" />
    <div>
      <BaseHeading :semantic-level="2" :class="$style.headline">
        <span :class="$style.displayDay">
          {{ displayDay }}
        </span><span :class="$style.timeRange">
          {{ getTimeRange }}
        </span>
      </BaseHeading>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { computed } from 'vue'
import type { AvailableTimeslot } from '~/terminierungsportal/types/appointmentTypes'
import BaseHeading from '~/base/components/heading/Heading.vue'

const { formatDate } = useDate()

const props = defineProps({
  timeslot: { type: Object as PropType<AvailableTimeslot>, required: true },
  selected: { type: Boolean, default: false }
})

const displayDay = computed((): string => {
  return formatDate(props.timeslot.from, 'dd, DD.MM.YYYY')
})

const getTimeRange = computed((): string => {
  const startTime = formatDate(props.timeslot.from, 'HH:mm')
  const endTime = formatDate(props.timeslot.to, 'HH:mm')

  return `${startTime} - ${endTime} Uhr`
})
</script>
<style module>
.base {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 10px 12px;
  background: var(--color-grey3);
  border-radius: 4px;
  transition: var(--transition-default);
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: calc(100% - 5px);
    height: 100%;
    background-color: var(--color-grey1);
    border-radius: 4px;
    z-index: -1;
  }

  &+& {
    margin-top: var(--space-xs);
  }
}

.selection {
  width: 22px;
  height: 22px;
  min-width: 22px;
  margin-right: 8px;
  border-radius: 50%;
  border: 2px solid var(--color-pacificblue);
  background-color: var(--color-white);
  transition: var(--transition-default);
}

.headline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.selected {
  box-shadow: 0 0 0 2px var(--color-pacificblue);
  background-color: var(--color-pacificblue);
}

.selectionSelected {
  border: 1px solid var(--color-pacificblue);
  background-color: var(--color-pacificblue);

  &:before {
    content: '';
    position: relative;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image:
      url("data:image/svg+xml;chartset=utf8,%3Csvg%20width%3D%2211%22%20height%3D%229%22%20viewBox%3D%220%200%2011%209%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M9.98937%200.22115C9.73397%200.229421%209.49204%200.333898%209.31494%200.512374C7.4146%202.35839%205.68119%204.17409%203.84531%205.98633L1.59496%204.24493H1.59481C1.39151%204.08734%201.13193%204.01436%200.873238%204.04222C0.61455%204.07008%200.377707%204.19646%200.215135%204.39351C0.0525567%204.59057%20-0.0227427%204.84217%200.00600044%205.09291C0.0347436%205.34365%200.165134%205.57322%200.368432%205.7308L3.31177%208.01314C3.50039%208.15897%203.73782%208.23239%203.97884%208.21919C4.21971%208.20598%204.44727%208.10731%204.61778%207.94175C6.73101%205.88909%208.62764%203.86897%2010.7006%201.85561H10.7007C10.8916%201.67669%2010.9996%201.43046%2011%201.17303C11.0003%200.915618%2010.8931%200.6691%2010.7025%200.489718C10.5121%200.31037%2010.2548%200.213439%209.98936%200.221128L9.98937%200.22115Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E%20");
    top: 4px;
    left: 4px;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.timeRange {
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
}

.displayDay {
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
}
</style>
